import React, { useEffect, useCallback, useState } from 'react';

import {
  Button,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@material-ui/core';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';

import { isNull, isArray, isEmpty, includes } from 'lodash';

import * as S from '../../styles';

export default function Tabela({
  title,
  cells,
  data,
  height,
  size,
  onCallback,
  onCallbackBico, }) {

  const [active, setActive] = useState({});

  // click in cell table
  const handleSetActiveItem = useCallback((item) => setActive(item), []);

  const handleSubmit = useCallback((item) => {
    !isEmpty(item) && onCallback(item);
  }, [active]);

  const handleSubmitBico = useCallback((item) => {
    !isEmpty(item) && onCallbackBico(item);
  }, [active]);

  

  return (
    <S.WrapperTabela height={height}>
      <S.WrapperTitle>{title}</S.WrapperTitle>
      <TableContainer>
        <Table stickyHeader aria-label="sticky table" size={size}>
          <TableHead>
            <TableRow>
              {cells.map((cell, index) => (
                <TableCell
                  key={`cell-index-head-${index}`}
                  align={cell.align || 'left'}
                >
                  {cell.label}
                </TableCell>
              ))}
              <TableCell>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>


            {data.map((item, index) => (
              <TableRow
                hover
                tabIndex={-1}
                key={`table-row-body-${index}`}
                onClick={() => handleSetActiveItem(item)}
              >

                {cells.map((cell, indexKey) => (


                  <TableCell
                    key={`table-cell-body-${indexKey}`}
                    align={cell.align || 'left'}
                  >
                    {!isUndefined(cell.rule) && cell.rule(item) ? (
                      <input
                        id={`input-${cell.id}-${index}`}
                        type="number"
                        defaultValue={item[cell.id]}
                        onKeyUp={({ target, key }) =>
                          key === 'Enter' &&
                          cell.callback(target.value, index, item)
                        }
                        onBlur={({ target }) =>
                          cell.callback(target.value, index, item)
                        }
                      />
                    ) : (

                        // cell.format ? cell.format(item[cell.id]) : item[cell.id]
                        item[cell.id] === 'Desconectado' ? <S.WrapperDesconectado> {item[cell.id]} </S.WrapperDesconectado> 
                                  : item[cell.id] === 'Conectado' ? <S.WrapperConectado> {item[cell.id]} </S.WrapperConectado> 
                                  : item[cell.id]


                      )}
                  </TableCell>
                ))}

                
                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleSubmitBico(item)}
                  //onClick={() => console.log(item)}
                >
                  {'Bicos'}
                </Button>

                <Button
                  size="small"
                  variant="outlined"
                  color="primary"
                  onClick={() => handleSubmit(item)}
                //onClick={() => console.log(active)}
                >
                  {'Usuários'}
                </Button>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </S.WrapperTabela>
  );
}

Tabela.propTypes = {
  title: PropTypes.string.isRequired,
  cells: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      align: PropTypes.string,
    })
  ).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  height: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  onCallback: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onCallbackBico: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
};

Tabela.defaultProps = {
  height: '100%',
  size: 'medium',
  onCallback: false,
};
